import { configureStore } from '@reduxjs/toolkit';
import otpReducer from './lib/features/OtpSlice'
import bankReducer from './lib/features/bankSlice'
import eligibilityReducer from './lib/features/eligibilitySlice';
import personalDetailsReducer from './lib/features/personalDetailsSlice';
import kycReducer from './lib/features/kycSlice';
import enachReducer from './lib/features/enachSlice';
import amountReducer from './lib/features/amountSlice';
import employmentReducer from './lib/features/employmentSlice';
import businessReducer from './lib/features/businessSlice';
import { authApi } from './lib/services/authApi';
import { bankApi } from './lib/services/bankApi';
import { personalDetailsApi } from './lib/services/personalDetailsApi';
import { eligibilityApi } from './lib/services/eligibilityApi';
import { enachApi } from './lib/services/enachApi';
import { kycApi } from './lib/services/kycApi';
import { fileApi } from './lib/services/fileApi';
import { employmentApi } from './lib/services/employmentApi';
import { businessApi } from './lib/services/businessApi';
import { tapApi } from './lib/middleware/TapClickApi';
import { vkycApi } from './lib/services/vkycApi';
import ckycReducer from "./KYC/CkycInputSlice";

export const store = configureStore({
  reducer: {
    otp: otpReducer,
    bank: bankReducer,
    eligibility: eligibilityReducer,
    personalDetails: personalDetailsReducer,
    kyc: kycReducer,
    enach: enachReducer,
    amount: amountReducer,
    employment: employmentReducer,
    business: businessReducer,
    ckyc: ckycReducer,
    [authApi.reducerPath]: authApi.reducer,
    [kycApi.reducerPath]: kycApi.reducer,
    [eligibilityApi.reducerPath]: eligibilityApi.reducer,
    [bankApi.reducerPath]: bankApi.reducer,
    [personalDetailsApi.reducerPath]: personalDetailsApi.reducer,
    [enachApi.reducerPath]: enachApi.reducer,
    [fileApi.reducerPath]: fileApi.reducer,
    [employmentApi.reducerPath]: employmentApi.reducer,
    [businessApi.reducerPath]: businessApi.reducer,
    [tapApi.reducerPath]: tapApi.reducer,
    [vkycApi.reducerPath]: vkycApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(authApi.middleware, kycApi.middleware, personalDetailsApi.middleware, eligibilityApi.middleware, bankApi.middleware, enachApi.middleware, fileApi.middleware, employmentApi.middleware, businessApi.middleware, tapApi.middleware, vkycApi.middleware)
});
